import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import Print from 'vue-print-nb'
Vue.use(Print);  
import store from './store'
require('./icons');
Vue.use(ElementUI);
import global_ from './components/global'
Vue.prototype.GLOBAL = global_

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(Layout)
});
